import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=0c85d9d6&scoped=true"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=0c85d9d6&prod&scoped=true&lang=css"
import style1 from "./ProjectLayout.vue?vue&type=style&index=1&id=0c85d9d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85d9d6",
  null
  
)

export default component.exports